import { createEntityStore } from '@redpanda/utils';
import { toast } from 'react-hot-toast';
import { getPayrolls, deletePayroll } from '../services/api';
import { storeMessages } from './storeMessages';
import { EmployeeRef } from './attendanceStore';

export interface Payroll {
  id: string;
  employeeId: string;
  periodYear: number;
  periodMonth: number;
  baseSalary: number;
  allowances: number;
  bonuses: number;
  overtimePay: number;
  laborInsurance: number;
  healthInsurance: number;
  laborPension: number;
  otherDeductions: number;
  netSalary: number;
  /** 公司負擔（不從薪資扣） */
  employerLaborInsurance?: number;
  employerHealthInsurance?: number;
  employerPension?: number;
  status: string; // DRAFT, CONFIRMED, PAID
  paidAt?: string | null;
  notes?: string | null;
  employee?: EmployeeRef;
}

export const usePayrollStoreBase = createEntityStore<Payroll>({
  entityName: 'payroll',
  fetchFn: (page: number) => getPayrolls(page),
  deleteFn: deletePayroll,
  toast,
  messages: storeMessages,
});
